<template>
    <div :class="'bulk-pricing-explained'" v-html="content">
    </div>
</template>

<script setup>
    import { defineProps } from 'vue';

    const props = defineProps({
        content: {
            type: String,
            required: true
        }
    });
</script>

<style scoped>
    .bulk-pricing-explained {
        width: 100%;
    }

</style>

<style>
    .bulk-pricing-explained p:last-of-type {
        margin: 0;
    }
</style>